/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventVignettePortalVisitedFromJSON(json) {
    return StreemApiAnalyticEventVignettePortalVisitedFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventVignettePortalVisitedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hotspotId': !exists(json, 'hotspot_id') ? undefined : json['hotspot_id'],
        'previousHotspotId': !exists(json, 'previous_hotspot_id') ? undefined : json['previous_hotspot_id'],
    };
}
export function StreemApiAnalyticEventVignettePortalVisitedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hotspot_id': value.hotspotId,
        'previous_hotspot_id': value.previousHotspotId,
    };
}
//# sourceMappingURL=StreemApiAnalyticEventVignettePortalVisited.js.map